import React from 'react';
import { Star } from 'lucide-react';
export function TestimonialsSection() {
  const testimonials = [{
    quote: 'Mi hijo ahora me pide estudiar, nunca había pasado.',
    author: 'María G.',
    role: 'Mamá de Tomás, 8 años'
  }, {
    quote: 'Le encanta, aprende sin darse cuenta.',
    author: 'Carolina P.',
    role: 'Mamá de Valentina, 7 años'
  }, {
    quote: '100% recomendado para niños curiosos.',
    author: 'Laura F.',
    role: 'Mamá de Mateo, 9 años'
  }];
  return <section className="bg-gray-50 py-10 px-4" data-id="element-152">
      <div className="max-w-3xl mx-auto" data-id="element-153">
        <h2 className="text-2xl md:text-3xl font-black text-center text-gray-900 mb-6 font-['Oswald'] uppercase" data-id="element-154">
          ⭐ Lo que dicen otros padres
        </h2>

        <div className="space-y-3" data-id="element-155">
          {testimonials.map((t, idx) => <div key={idx} className="bg-white p-4 rounded-lg shadow-md border-l-4 border-green-500" data-id="element-156">
              <div className="flex gap-0.5 text-yellow-400 mb-2" data-id="element-157">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-3.5 h-3.5 fill-current" data-id="element-158" />)}
              </div>
              <p className="text-base font-medium text-gray-800 italic mb-2" data-id="element-159">
                ⭐ "{t.quote}"
              </p>
              <p className="text-sm font-bold text-gray-900" data-id="element-160">
                {t.author}{' '}
                <span className="font-normal text-gray-500" data-id="element-161">– {t.role}</span>
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}